import useApi from "hooks/useApi";
import { useMutation } from "react-query";
import { handleAxiosError } from "./utils";

export interface GetReportDownloadUrlResponse {
  url: string;
}

const GET_REPORT_DOWNLOAD_URL_ENDPOINT = "/get-report-download-url";

export default function useQueryGetReportDownloadUrl() {
  const api = useApi();

  const fetchDownloadUrl = async (key: string): Promise<GetReportDownloadUrlResponse> => {
    try {
      const { data } = await api.get<GetReportDownloadUrlResponse>(GET_REPORT_DOWNLOAD_URL_ENDPOINT, {
        params: { key },
      });
      return data;
    } catch (e) {
      return handleAxiosError(e);
    }
  };

  return useMutation<GetReportDownloadUrlResponse, string, string>(fetchDownloadUrl);
}
